import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ReviewMode from "./ReviewMode";
import ReviewSummary from "./ReviewSummary";

// Import with absolute path if using Create React App
import learnBg from '../../../assets/review.png';
import api from "../../../api";

const ReviewContainer = ({ token }) => {
    const { deckId } = useParams();
    const [deck, setDeck] = useState(undefined);
    const [showSummary, setShowSummary] = useState(false);
    const [reviewResults, setReviewResults] = useState([]);
    const [imageLoaded, setImageLoaded] = useState(false);

    // Check if the image is loaded properly
    useEffect(() => {
        const img = new Image();
        img.src = learnBg;
        img.onload = () => {
            setImageLoaded(true);
            console.log("Background image loaded successfully");
        };
        img.onerror = () => {
            console.error("Failed to load background image:", learnBg);
        };
    }, []);

    // Fetch deck object
    useEffect(() => {
        const res = api.get(`/decks/${deckId}`).then((res) => {
            console.log('Response ', res.data);
            setDeck(res.data.deck);
        })
        
    }, []);
    const handleReviewComplete = (results) => {
        setReviewResults(results);
        setShowSummary(true);
    };

    const handleRestartReview = () => {
        setShowSummary(false);
        setReviewResults([]);
    };

    return (
        <>
            {!showSummary ? (
                <div style={{ 
                    position: 'relative',
                    zIndex: 1,
                    width: '100%',
                    height: '100%',
                    minHeight: '100vh'  // Ensure the container has height
                }}>
                    <div style={{
                        background: `rgb(216, 241, 247)`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover',
                        opacity: 0.5,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: -1,
                        width: '100%',
                        height: '100%'
                    }} />
                    {imageLoaded ? null : <p>Loading background image...</p>}
                    <ReviewMode
                        token={token}
                        onReviewComplete={handleReviewComplete}
                        deck={deck}
                    />
                </div>
            ) : (
                <ReviewSummary
                    results={reviewResults}
                    onRestart={handleRestartReview}
                    deckId={deckId}
                />
            )}
        </>
    );
};

export default ReviewContainer;